var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraggable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "draggable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 4,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 4,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 4,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 4,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 4,
    height: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 4,
    height: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    className: "st0",
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.1a73aee76c86e889b9e35267a77e3eca.svg";
export { ForwardRef as ReactComponent };